import { LoggerModule, ApiModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { FavoritesService } from "./favorites.service";
import { UserModule } from "../user";

export const FavoritesModule: Module = {
  name: "FavoritesModule",
  modules: [ApiModule, LoggerModule, UserModule],
  providers: [FavoritesService],
};
